import './OnboardingInputs.css';
import React, { useState } from 'react';

const { extractPhone, extractCashTag, extractPayPalUsername, extractVenmoUsername, extractPhoneOrEmail } = require('../utils/PaymentsRegex');


const PaymentsSelector = ({ onPaymentSelect, selectedPayments, languageSetting }) => {
  var paymentOptions = {
    PAYPAL: { name: 'PayPal', prompt: languageSetting === "ENGLISH" ? 'Enter Your PayPal Username or PayPal.me URL.' : 'Ingresa tu nombre de usuario de PayPal o URL de PayPal.me.' },
    VENMO: { name: 'Venmo', prompt: languageSetting === "ENGLISH" ? 'Enter Your Venmo Username or Venmo Payment URL.' : 'Ingresa tu nombre de usuario de Venmo o URL de pago de Venmo.' },
    ZELLE: { name: 'Zelle', prompt: languageSetting === "ENGLISH" ? 'Enter the email or phone number associated with your Zelle account' : 'Ingresa el correo electrónico o número de teléfono asociado con tu cuenta Zelle' },
    CASHAPP: { name: 'CashApp', prompt: languageSetting === "ENGLISH" ? 'Enter Your CashApp CashTag or your CashApp payment URL.' : 'Ingresa tu CashTag de CashApp o tu URL de pago de CashApp.' },
    APPLEPAY: { name: 'Apple Pay', prompt: languageSetting === "ENGLISH" ? 'Enter Your Phone Number' : 'Ingresa tu número de teléfono' },
    // Add more payment options here
  };

  const [paymentsError, setPaymentsError] = useState({
    PAYPAL: '',
    VENMO: '',
    ZELLE: '',
    CASHAPP: '',
    APPLEPAY: ''
    // Add more payment options here
  });


  const newPayments = Object.keys(paymentOptions).map((x) => ({ name: paymentOptions[x].name, id: x, showInput: selectedPayments[x] ? selectedPayments[x].showInput : false, value: selectedPayments[x] ? selectedPayments[x].value : '', prompt: paymentOptions[x].prompt }))

  const handleDivClick = (option) => { 
    if(newPayments[option].showInput){newPayments[option].value=''}
    newPayments[option].showInput = !newPayments[option].showInput; 

    onPaymentSelect(newPayments[option]); 
  };

  const handleInputChange = (event) => {
    const value = event.target.value;
    const newPayment = selectedPayments[event.target.dataset.paymentName]
    newPayment['value'] = value;
    onPaymentSelect(newPayment);
  };

  // New handleBlur function to trigger validation
  const handleInputBlur = (event) => {
    const value = event.target.value;
    const paymentType = event.target.dataset.paymentName;

    const this_payment = newPayments.filter(x => x['id'] == paymentType)

    const option = this_payment[0];
    let option_val = {}
    const option_id = option['id']

    if(option_id == 'PAYPAL') {
      option_val = extractPayPalUsername(option['value'])
    } else if(option_id == 'VENMO') {
      option_val = extractVenmoUsername(option['value'])
    } else if(option_id == 'ZELLE' ) {
      option_val = extractPhoneOrEmail(option['value'])
    }  else if(option_id == 'CASHAPP' ) {
      option_val = extractCashTag(option['value'])
    } else if(option_id == 'APPLEPAY' ) {
      option_val = extractPhone(option['value'])
    } ;
    option['value'] = option_val['return_string'];
    setPaymentsError((paymentsError) => ({...paymentsError, [option_id]: option_val['error']}))
    onPaymentSelect(option);
  };
  

  return (
    <div className="container">
      {Object.keys(newPayments).map((option) => (
        <div key={option} className="option-container">
          <div
            onClick={() => handleDivClick(option)}
            className="option-button"
          >
            {newPayments[option].name} {newPayments[option].showInput}
          </div>
          {newPayments[option].showInput && (
            <div className="input-container">
              <p className="help-text">{newPayments[option].prompt}</p>
              <input
                type="text"
                value={newPayments[option].value}
                onChange={(event) => handleInputChange(event)}
                onBlur={(event) => handleInputBlur(event)}
                className="input-field"
                data-payment-name={newPayments[option].id}
              />
              <p className="error-text">{paymentsError[newPayments[option].id]}</p>
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default PaymentsSelector;
